import type { BaseNetworkHandler, Config } from '@snapchat/graphene';
import { Graphene, FetchNetworkHandler } from '@snapchat/graphene';
import type { BasePermission, EmptyObject, GrapheneLoggingContext } from '@snapchat/logging';
import { AbstractGrapheneEventListener } from '@snapchat/logging';

/**
 * Graphene EventListener suitable for usage on the client.
 *
 * TODO: This uses 'fetch' for network which works in Node since Node18. Wonder if this and the
 * server implementation can be consolidated.
 */
export class GrapheneClientEventListener<
  LoggingContext extends GrapheneLoggingContext = GrapheneLoggingContext,
  CustomEvents extends EmptyObject = EmptyObject,
  LoggingPermission extends BasePermission = BasePermission
> extends AbstractGrapheneEventListener<LoggingContext, CustomEvents, LoggingPermission> {
  /** @override istanbul ignore next */
  protected getNetworkHandler = (options: Config): BaseNetworkHandler => {
    return new FetchNetworkHandler(options);
  };

  /** @override istanbul ignore next */
  protected getClient = (): Graphene => {
    return new Graphene();
  };
}
